import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wrapper-outer",
  style: {
    "line-height": "1.5"
  }
};
const _hoisted_2 = {
  class: "div-086"
};
const _hoisted_3 = {
  class: "submit-div"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_iop_event = _resolveComponent("iop-event");
  const _component_sensitive_words = _resolveComponent("sensitive-words");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_add_aside = _resolveComponent("add-aside");
  const _component_offer_ref_demand_dialog = _resolveComponent("offer-ref-demand-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_scrollbar, {
    class: "body-scroll"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      ref: "formRef",
      "label-position": 'top',
      "label-width": "80px",
      model: _ctx.demand,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "需求名称",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "prop-val-row"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _ctx.demand.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.demand.name = $event),
                placeholder: "请输入需求名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "需求人",
            prop: "=userName"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "prop-val-row prop-val-text"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.userInfo.userName) + "    " + _toDisplayString($setup.userInfo.depName), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "短信有效期",
            prop: "validDate"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, null, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: _ctx.demand.validDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.demand.validDate = $event),
                "value-format": "YYYY-MM-DD HH:mm:ss",
                format: "YYYY-MM-DD",
                type: "daterange",
                disabledDate: $setup.disabledDate,
                "default-time": _ctx.defaultRangeTime,
                "range-separator": "~",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期"
              }, null, 8, ["modelValue", "disabledDate", "default-time"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "联系方式"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "prop-val-row prop-val-text"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString($setup.userInfo.mobile), 1)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "需求内容",
          prop: "remark",
          style: {
            "width": "100%",
            "display": "none"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            rows: 4,
            modelValue: _ctx.demand.remark,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.demand.remark = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col margin-10-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "业务归属部门",
            prop: "smsType",
            class: "sms-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _ctx.belongDepart,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.belongDepart = $event),
              placeholder: "请选择",
              style: {
                "margin-left": "2%"
              },
              onChange: $setup.belongDepartChange
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.belongDeparts, depart => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: depart.code,
                  label: depart.label,
                  value: depart.code
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col margin-10-0"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 14
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "IOP短信发送渠道",
            prop: "smsType",
            class: "sms-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _ctx.demand.smsType,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.demand.smsType = $event),
              placeholder: "请选择",
              style: {
                "margin-left": "2%"
              },
              onChange: $setup.smsTypeChange
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.smsTypes, type => {
                return _withDirectives((_openBlock(), _createBlock(_component_el_option, {
                  key: type.id,
                  label: type.nodeName,
                  value: type.id
                }, null, 8, ["label", "value"])), [[_vShow, $setup.getDisabled(type.id)]]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue", "onChange"])]),
            _: 1
          })]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "IOP事件",
            prop: "iopEvent",
            class: "sms-type"
          }, {
            default: _withCtx(() => [_createVNode(_component_iop_event, {
              channelCode: _ctx.demand.smsType,
              positionId: _ctx.demand.positionId,
              "onUpdate:positionId": _cache[5] || (_cache[5] = $event => _ctx.demand.positionId = $event)
            }, null, 8, ["channelCode", "positionId"])]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, _ctx.demand.smsType === 'RTFLOW' || _ctx.demand.smsType === 'EC10001']])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "短信内容",
          prop: "smsContent",
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            rows: 4,
            modelValue: _ctx.demand.smsContent,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.demand.smsContent = $event),
            maxlength: "500",
            "show-word-limit": "",
            onBlur: $setup.checkSensWord
          }, null, 8, ["modelValue", "onBlur"])]),
          _: 1
        }), _createVNode(_component_sensitive_words, {
          "sens-words-list": [_ctx.sensWords]
        }, null, 8, ["sens-words-list"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col form-margin"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          ref: "upload",
          multiple: "",
          "http-request": $setup.fileUpload,
          "on-remove": $setup.handleRemove,
          "on-preview": $setup.handlePreview,
          limit: 5,
          "on-exceed": $setup.handleExceed,
          "file-list": _ctx.fileList
        }, {
          default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("span", {
            class: "form-font"
          }, "需求附件：", -1)), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            plain: ""
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("上传附件", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["http-request", "on-remove", "on-preview", "on-exceed", "file-list"])]),
        _: 1
      }), _createVNode(_component_el_row, {
        class: "prop-col form-margin offer-div"
      }, {
        default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("span", {
          class: "form-font"
        }, "关联产品offerId：", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offerIds, offerId => {
          return _openBlock(), _createBlock(_component_el_tag, {
            key: offerId,
            class: "mx-1",
            closable: "",
            "disable-transitions": false,
            onClose: $event => $setup.handleClose(offerId)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(offerId), 1)]),
            _: 2
          }, 1032, ["onClose"]);
        }), 128)), _ctx.inputVisible ? (_openBlock(), _createBlock(_component_el_input, {
          key: 0,
          ref: "InputRef",
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _ctx.inputValue = $event),
          class: "ml-1 w-20",
          onKeyup: _withKeys($setup.handleInputConfirm, ["enter"]),
          onBlur: $setup.handleInputConfirm
        }, null, 8, ["modelValue", "onKeyup", "onBlur"])) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "button-new-tag ml-1",
          size: "small",
          onClick: $setup.showInput
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" + 新 增 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])), _ctx.offerIds.length > 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          link: "",
          onClick: _cache[8] || (_cache[8] = $event => _ctx.offerDemandVisible = true)
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" 查看相关需求 ", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      type: "primary",
      round: "",
      onClick: _cache[9] || (_cache[9] = $event => $setup.handleSubmit(0))
    }, {
      default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("保存草稿 ", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      disabled: !_ctx.sensChecked,
      type: "primary",
      round: "",
      onClick: _cache[10] || (_cache[10] = $event => $setup.handleSubmit(2))
    }, {
      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("提交审核 ", -1)]))]),
      _: 1
    }, 8, ["disabled"])])]),
    _: 1
  })]), _createVNode(_component_add_aside, {
    procs: $setup.smsProcs
  }, null, 8, ["procs"]), _createVNode(_component_offer_ref_demand_dialog, {
    visible: _ctx.offerDemandVisible,
    "onUpdate:visible": _cache[11] || (_cache[11] = $event => _ctx.offerDemandVisible = $event),
    "offer-ids": _ctx.offerIds,
    "onUpdate:offerIds": _cache[12] || (_cache[12] = $event => _ctx.offerIds = $event)
  }, null, 8, ["visible", "offer-ids"])], 64);
}